import { ReportImg } from "@/components/report/commons/ReportImg";
import { ListItem } from "@mui/material";
import HelpDialogLayout, {
  BodyTypographies,
  ContentStack,
  HelpDialogLayoutProps,
  HelpDialogList,
} from "./HelpDialogLayout";

export interface TurnOverDialogProps extends HelpDialogLayoutProps {}
export default function TurnOverDialog(props: TurnOverDialogProps) {
  return (
    <HelpDialogLayout {...props}>
      <ContentStack>
        <BodyTypographies
          contents={[
            "一晩に10～20回程度の寝返りは、正常とされています。寝返りには、体の圧力を分散したり、温度を調整したりする役割があります。",
            "回数が多すぎると睡眠を妨げてしまうこともありますが、あまり神経質になり過ぎない方が良いでしょう。",
          ]}
        />
        <BodyTypographies
          contents={[
            "寝返りが多すぎる、または少なすぎる場合は、寝具が体に合っているかを確認しましょう。",
          ]}
        />
        <HelpDialogList>
          <ListItem>
            <BodyTypographies
              contents={[
                "枕やマットレス：立っている姿勢、つまり、首・肩・腰・ひざ・くるぶしが一直線に並ぶ状態、を横にした姿勢が最もストレスの少ない寝姿勢だと言われています。体重の影響や寝る姿勢などの影響もあり、硬さや形状は人それぞれ異なるため、自分が心地よいと感じるものを選ぶことが大切です。",
              ]}
            />
          </ListItem>
        </HelpDialogList>
        <ReportImg
          image_name="image_report_turn_over.png"
          style={{ width: "100%", padding: "24px 0" }}
        />
        <HelpDialogList>
          <ListItem>
            <BodyTypographies
              contents={[
                "温度・湿度：布団の中の温度は29～33度、寝室の室温は13～29度が理想とされているため、それより暑すぎたり寒すぎたりしていないかチェックしましょう。湿度は40～60％がよいとされていますが、高すぎると発汗による放熱が上手くいかなくなってしまいます。寝具や空調機器を活用しながら、就寝環境を整えましょう。",
              ]}
            />
          </ListItem>
        </HelpDialogList>
        <BodyTypographies
          contents={[
            "最後にパジャマは、サイズは少しゆとりのあるものを選び、体の動きを妨げないようにしましょう。特に袖や裾が締め付けないよう注意をしましょう。",
          ]}
        />
      </ContentStack>
    </HelpDialogLayout>
  );
}
